import React, { useMemo } from 'react';
import { TouchableOpacity } from '../../common';
import {
  PaymentAccountsMethodType,
  PaymentNotificationType,
} from '@zonofi/zono-money-store';
import { upperCase } from 'lodash';
import { SVGS } from '../../assets';
import { Divider } from '../../components';

interface PaymentMethodsCardProps {
  item: PaymentAccountsMethodType;
  onPress: (item: PaymentAccountsMethodType) => void;
  isLast?: boolean;
  isSelected?: boolean;
}

export const PaymentMethodsCard: React.FC<PaymentMethodsCardProps> = ({
  item,
  isLast,
  onPress,
  isSelected,
}) => {
  const paymentConfig = useMemo(() => {
    if (item.type === 'upi') {
      return {
        icon: SVGS.UpiIcon,
        title: 'UPI',
        name: item.upiAccountHolderName || '—',
        subText: item.upiId || '—',
      };
    } else {
      return {
        icon: SVGS.BankIcon,
        title: upperCase(item.bankName || 'BANK'),
        name: item.accountHolderName || '—',
        subText: [
          item.accountNumber
            ? `**********${item.accountNumber.slice(-4)}`
            : null,
          item.ifscCode,
        ]
          .filter(Boolean)
          .join(' • '),
      };
    }
  }, [item]);

  const notificationLabels = useMemo(() => {
    const stylesMap = {
      advise: { bg: '#CCEFE0', text: '#135439' },
      reminder: { bg: '#E6F0FF', text: '#002E73' },
    };

    if (item?.paymentNotificationtype === PaymentNotificationType.All) {
      return [
        { label: 'Payment Advise', ...stylesMap.advise },
        { label: 'Payment Reminders', ...stylesMap.reminder },
      ];
    }
    if (
      item?.paymentNotificationtype === PaymentNotificationType.PaymentAdvice
    ) {
      return [{ label: 'Payment Advise', ...stylesMap.advise }];
    }
    if (
      item?.paymentNotificationtype === PaymentNotificationType.PaymentReminders
    ) {
      return [{ label: 'Payment Reminders', ...stylesMap.reminder }];
    }
    return [];
  }, [item]);

  const { icon, title, name, subText } = paymentConfig;

  return (
    <>
      <TouchableOpacity
        className="payment-method-card-container"
        onPress={() => onPress(item)}
      >
        <div className="payment-method-card-container-left">
          <img
            src={isSelected ? SVGS.CircleSelected : SVGS.CircleUnselected}
            width={28}
            height={28}
            alt="checkbox"
            style={{ alignSelf: 'center' }}
          />

          <div className="payment-method-card-view">
            <img src={icon} width={40} height={40} />
          </div>
        </div>
        <div className="payment-method-card-info">
          <span className="payment-method-card-info--title font-regular">
            {title}
          </span>
          <span className="payment-method-card-info--name font-semibold">
            {name}
          </span>
          <span className="payment-method-card-info--subtext font-regular">
            {subText}
          </span>

          <div className="payment-method-card-notify">
            {notificationLabels?.map((item) => (
              <div
                className="payment-method-card-notify-view"
                style={{ background: item.bg }}
              >
                <span
                  className="payment-method-card-notify-text font-regular"
                  style={{ color: item.text }}
                >
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </TouchableOpacity>

      {!isLast && <Divider className="payment-method-card-divider" />}
    </>
  );
};
